import React from "react";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import ServiceHeader from "../components/ServiceHeader";
import news_img from "../static/img/team.png"; // Using an existing image for now
import "../static/css/About.css"; // Reuse About.css for consistency or create new

function NewsPage() {
    return (
        <>
            <Nav />
            <ServiceHeader
                image={news_img}
                title={"What's New"}
                description={"Stay updated with the latest news and updates from SPP IPE."}
            />

            <div className="about-content" style={{ 
                minHeight: "500px", 
                display: "flex", 
                flexDirection: "column",
                justifyContent: "center", 
                alignItems: "center",
                background: "linear-gradient(to bottom, #ffffff, #f9f9f9)"
            }}>
                <div className="about-container" style={{ 
                    textAlign: "center",
                    padding: "60px",
                    borderRadius: "20px",
                    boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
                    background: "#fff"
                }}>
                    <h2 style={{ 
                        fontSize: "4rem", 
                        color: "#d4af37", 
                        marginBottom: "10px",
                        fontWeight: "800",
                        letterSpacing: "-1px"
                    }}>Coming Soon</h2>
                    <div style={{ 
                        width: "80px", 
                        height: "4px", 
                        background: "#d4af37", 
                        margin: "0 auto 30px" 
                    }}></div>
                    <p style={{ 
                        fontSize: "1.4rem", 
                        color: "#555",
                        maxWidth: "600px",
                        lineHeight: "1.6"
                    }}>
                        We are currently curating the latest news and updates for you. 
                        Stay tuned for our upcoming announcements!
                    </p>
                </div>
            </div>

            <Footer />
        </>
    );
}

export default NewsPage;
